import { axiosFactory, errorHandler, currentPage } from '@/configs/axios'

export const addOrganization = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('organizations/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const editOrganization = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('organizations/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const organizationSummaryList = {
  api: () => {
    return axiosFactory()
      .auth.get(`organizations/summaries/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const organizationList = {
  api: () => {
    return axiosFactory()
      .auth.get(`organizations/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getAOrganization = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('organizations/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const usersListSummary = {
  api: () => {
    return axiosFactory()
      .auth.get(`users/summaries/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const usersList = {
  api: () => {
    return axiosFactory()
      .auth.get(`users/${currentPage()}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getUser = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('users/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const editUser = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('users/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const resetPassUser = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('users/' + payload.id + '/passwords/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const addUser = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('users/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getPolicies = {
  api: () => {
    return axiosFactory()
      .auth.get(`users/policies/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const assignDriverOrg = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('drivers/' + payload.id + '/organizations/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
export const assignVehcileOrg = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('vehicles/companies/' + payload.id + '/organizations/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
export const assignGeofence = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('geofences/' + payload.id + '/organizations/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const assignTag = {
  api: (payload) => {
    return axiosFactory()
      .auth.put(
        'vehicles/companies/tags/' + payload.id + '/organizations/',
        payload
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
